export default [
    {
        "id": 0,
        "descripcion": "NO",
    },
    {
        "id": 1,
        "descripcion": "COLEGIO",
    },
    {
        "id": 2,
        "descripcion": "IMPUGNACION",
    },
    {
        "id": 3,
        "descripcion": "MIXTO",
    }
]